import React, { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const GuidesSection = () => {
  const [guides, setGuides] = useState([]);

  useEffect(() => {
    const fetchGuides = async () => {
      try {
        const res = await axios.get(`${API}/guides`);
        setGuides(res.data);
      } catch (err) {
        console.error('Failed to fetch guides:', err);
      }
    };
    fetchGuides();
  }, []);

  if (guides.length === 0) return null;

  return (
    <section className="section-padding" style={{
      background: '#0f0a1e',
    }}>
      <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
        <h2 style={{
          textAlign: 'center',
          fontSize: 'clamp(32px, 4vw, 48px)',
          fontWeight: 700,

          marginBottom: '12px',
          color: '#00d4ff',
        }}>
          Your Spiritual Guide
        </h2>
        <div className="section-divider" style={{ marginBottom: '60px' }} />

        <div className="grid-guides">
          {guides.map((guide, index) => (
            <div
              key={guide.guide_id || index}
              className="guide-card glass-card"
              style={{
                padding: '40px 32px',
                textAlign: 'center',
                position: 'relative',
                overflow: 'hidden',
                transition: 'transform 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease',
              }}
              onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-4px)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; }}
            >
              {/* Ambient background sparkles */}
              <div className="guide-sparkle" style={{ top: '10%', left: '12%', animationDelay: '0s' }} />
              <div className="guide-sparkle" style={{ top: '18%', right: '14%', animationDelay: '0.6s' }} />
              <div className="guide-sparkle" style={{ bottom: '22%', left: '18%', animationDelay: '1.2s' }} />
              <div className="guide-sparkle" style={{ bottom: '12%', right: '20%', animationDelay: '1.8s' }} />

              {/* Portrait halo */}
              <div className="guide-portrait-wrap">
                {/* Rotating conic aura */}
                <div className="guide-aura" />
                {/* Pulsing gold glow */}
                <div className="guide-glow" />
                {/* Orbiting sparkle */}
                <div className="guide-orbit">
                  <span className="guide-orbit-dot" />
                </div>
                {/* Photo */}
                <div
                  className="guide-portrait-ring"
                  style={{
                    background: index === 0
                      ? 'linear-gradient(135deg, #ffd700, #ff8c00)'
                      : 'linear-gradient(135deg, #8b5cf6, #06b6d4)',
                  }}
                >
                  <img
                    src={guide.image}
                    alt={guide.name}
                    style={{
                      width: '100%',
                      height: '100%',
                      borderRadius: '50%',
                      objectFit: 'cover',
                      border: '3px solid #0f0a1e',
                    }}
                  />
                </div>
              </div>

              <h3 className="guide-name" style={{
                fontSize: '22px',
                fontWeight: 700,
                color: '#00d4ff',
                marginBottom: '6px',
                position: 'relative',
              }}>
                <span className="guide-name-text">{guide.name}</span>
              </h3>
              <p style={{
                fontSize: '13px',
                color: '#ffd700',
                fontWeight: 600,
                letterSpacing: '1px',
                marginBottom: '16px',
                position: 'relative',
              }}>
                {guide.title}
              </p>
              <p style={{
                fontSize: '14px',
                color: '#b0adc0',
                lineHeight: 1.7,
                position: 'relative',
              }}>
                {guide.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GuidesSection;
